export var NotificationType;
(function (NotificationType) {
    NotificationType["error"] = "error";
    NotificationType["info"] = "info";
    NotificationType["success"] = "success";
    NotificationType["warning"] = "warning";
})(NotificationType || (NotificationType = {}));
